var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useEffect, useContext } from "react";
import { DigiThemeManagerContext } from "../digitheme/DigiThemeManager";
import ListField from "./ListField";
import MultiSelectListField from "./MultiSelectListField";

var AclField = function AclField(props) {
  var config = props.config,
      value = props.value,
      _onValueChange = props.onValueChange;
  var single = config.single,
      allowedRoles = config.allowedRoles;

  var digiThemeManagerContext = useContext(DigiThemeManagerContext);

  useEffect(function () {
    digiThemeManagerContext.loadGroupRoles();
  }, []);

  var roles = digiThemeManagerContext.getGroupRoles();

  if (!roles) return React.createElement("div", { className: "loading" });

  var items = roles.map(function (role) {
    return { key: role.uuid, value: role.name };
  });

  if (allowedRoles && allowedRoles.length > 0) {
    items = items.filter(function (r) {
      return allowedRoles.indexOf(r.key) !== -1;
    });
  }

  items.sort(function (a, b) {
    return a.value.localeCompare(b.value, "en", { numeric: true });
  });

  return single ? React.createElement(ListField, _extends({
    isDictionary: true,
    items: items
  }, props, {
    value: Array.isArray(value) ? value[0] : value
  })) : React.createElement(MultiSelectListField, _extends({
    isDictionary: true,
    items: items
  }, props, {
    onValueChange: function onValueChange(value) {
      return _onValueChange(value.join(","));
    },
    value: value ? value.split(",") : []
  }));
};

export default AclField;